import { FC, useRef } from "react";
import {
  FinancialApplicationFormSectionContextType,
  FinancialApplicationFormValidationDisplayBehavior,
  useFinancialApplicationFormSectionValidation,
} from "@/hooks/useFinancialApplicationFormSectionValidation";
import { TaskExecutionModuleFormProps } from "@bolt/task";
import { KeyPersonIdentificationDocumentsForm } from "../KeyPersonIdentificationDocumentsForm/KeyPersonIdentificationDocumentsForm";
import { KeyPersonForm } from "../KeyPeople/KeyPersonForm";
import { useKeyPerson } from "@/hooks/useKeyPerson";
import { useFinancialApplicationCoreData } from "@/hooks/useFinancialApplicationCoreData";
import { FieldFormV2Module, LoadingV2 } from "@ucl/library";
import { KeyPerson } from "@/types/KeyPerson";
import { FinancialApplicationSection } from "@/types/enums";
import "./KeyPersonExpressionSchemaTaskExecutionTypeForm.scss";

export interface KeyPersonExpressionSchemaTaskExecutionTypeFormProps
  extends TaskExecutionModuleFormProps {}

export const KeyPersonExpressionSchemaTaskExecutionTypeForm: FC<
  KeyPersonExpressionSchemaTaskExecutionTypeFormProps
> = (props) => {
  // Early return if required IDs are not available
  if (!props.parentEntityId || !props.entityId) {
    return <LoadingV2 />;
  }

  const fieldFormModule = useRef<FieldFormV2Module<KeyPerson> | null>(null);

  const {
    formValue,
    setFormValue,
    saveFormData,
    debitCardInformationRenderKey,
    digitalBankingInformationRenderKey,
  } = useKeyPerson(props.parentEntityId, props.entityId);

  const { conditionalFlags } = useFinancialApplicationCoreData(props.parentEntityId);

  const { getCollectionValidationErrors } = useFinancialApplicationFormSectionValidation(
    props.parentEntityId,
    FinancialApplicationSection.KeyPeople,
    FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors,
    FinancialApplicationFormSectionContextType.Task
  );

  const validationErrors = getCollectionValidationErrors("KeyPeople");

  if (!formValue) {
    return <LoadingV2 />;
  }

  const alreadyHasControlPersonRole = false; // TODO: Implement this

  return (
    <>
      <KeyPersonForm
        fieldFormModule={fieldFormModule}
        formValue={formValue}
        setFormValue={setFormValue}
        saveFormData={saveFormData}
        debitCardInformationRenderKey={debitCardInformationRenderKey}
        digitalBankingInformationRenderKey={digitalBankingInformationRenderKey}
        conditionalFlags={conditionalFlags}
        validationErrors={
          validationErrors.fieldSchemaCollectionMemberValidationErrors[props.entityId] || {}
        }
        alreadyHasControlPersonRole={alreadyHasControlPersonRole}
        validationContextType={FinancialApplicationFormSectionContextType.Task}
        availableFields={props.availableFields}
        shouldShowDigitalBankingFields={true}
        shouldShowDebitCardFields={true}
      />
      <KeyPersonIdentificationDocumentsForm
        keyPersonId={props.entityId}
        availableFields={props.availableFields}
        autoValidationBehavior={
          FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors
        }
        showHeader={true}
        validationContextType={FinancialApplicationFormSectionContextType.Task}
        governmentIdType={formValue.governmentIdInformation?.governmentIdType}
      />
    </>
  );
};
